export default {
  CHILD: 'Child',
  ACCOUNT_HOLDER: 'Account Holder',
  FACILITY_PATIENT: 'Facility Patient'
};
